var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSolidLayout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_12824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 6.3368V13.3375C14 13.5232 13.9263 13.7012 13.795 13.8325C13.6637 13.9638 13.4857 14.0375 13.3 14.0375H7.7V6.3368H14ZM6.3 10.5368V14.0375H0.7C0.514348 14.0375 0.336301 13.9638 0.205025 13.8325C0.0737498 13.7012 0 13.5232 0 13.3375V10.5368H6.3ZM6.3 1.4375V9.1368H0V2.1375C0 1.95185 0.0737498 1.7738 0.205025 1.64253C0.336301 1.51125 0.514348 1.4375 0.7 1.4375H6.3ZM13.3 1.4375C13.4857 1.4375 13.6637 1.51125 13.795 1.64253C13.9263 1.7738 14 1.95185 14 2.1375V4.9368H7.7V1.4375H13.3Z",
    fill: "#AEB5BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_12824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolidLayout);
export default __webpack_public_path__ + "static/media/icon-solid-layout.4f2584a1.svg";
export { ForwardRef as ReactComponent };